import { render } from "./cell_money.vue?vue&type=template&id=f2e799d4"
import script from "./cell_money.vue?vue&type=script&lang=ts"
export * from "./cell_money.vue?vue&type=script&lang=ts"
script.render = render

export default script